// Live "Showing X of Y {noun}" pill for page headers — ticks up as rows load.
// Pass a SINGULAR noun (e.g. "contact"); it pluralises automatically.
// Compact on small screens ("50/2147"), full on sm+ ("Showing 50 of 2147 contacts").
const IRREGULAR = { person: "people", entry: "entries", company: "companies", quote: "quotes" };

function pluralise(noun, n) {
  if (!noun) return "";
  if (n === 1) return noun;
  if (IRREGULAR[noun]) return IRREGULAR[noun];
  if (/(s|x|z|ch|sh)$/.test(noun)) return `${noun}es`;
  if (/[^aeiou]y$/.test(noun)) return `${noun.slice(0, -1)}ies`;
  return `${noun}s`;
}

export default function LiveCount({ shown, total, noun = "", testId = "live-count" }) {
  const t = Number(total) || 0;
  const s = Math.min(Number(shown) || 0, t || Number(shown) || 0);
  const label = pluralise(noun, t);
  return (
    <span
      data-testid={testId}
      title={`Showing ${s} of ${t}${label ? ` ${label}` : ""}`}
      className="inline-flex items-center gap-1 shrink-0 max-w-full px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full border border-white/10 bg-white/[0.03] text-[10px] sm:text-[11px] font-mono text-slate-300 whitespace-nowrap"
    >
      <span className="hidden sm:inline text-slate-500">Showing&nbsp;</span>
      <b className="text-white tabular-nums">{s}</b>
      <span className="text-slate-500">
        <span className="sm:hidden">/</span>
        <span className="hidden sm:inline">&nbsp;of&nbsp;</span>
      </span>
      <b className="text-white tabular-nums">{t}</b>
      {label ? <span className="hidden sm:inline text-slate-500 truncate">&nbsp;{label}</span> : null}
    </span>
  );
}
